import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'
import { responsiveImageFragment } from '../fragments/images'

export const iscrizioniPage = gql`
  ${seoFragment}
  ${responsiveImageFragment}

  query IscrizioniPage($locale: SiteLocale) {
    paginaIscrizioni(locale: $locale) {
      seo {
        ...SeoFragment
      }
      titolo
      slug
      hero {
        titolo
        testo
        cards {
          titolo
          testo
          id
          coloreCard {
            hex
          }
          cta {
            testo
            link
            evento
            file {
              url
            }
          }
        }
      }
      immagineTesto {
        titolo
        id
        card {
          titolo
          testo
          immagine {
            responsiveImage(imgixParams: { fm: webp, q: "50" }) {
              ...ResponsiveImageFragment
            }
          }
        }
      }
    }
  }
`
